import { http } from '@/utils/http.util';

export default class ModuleTypeService {
   async getModuleTypes() {
      return await http.get('/api/module-type').then((response) => {
         return response.data;
      });
   }
}
